import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ['list', 'trigger'];

  toggle() {
    if (this.#isListShown()) {
      this.#hideList();
    } else {
      this.#showList();
    }
  }

  // hide all the other dropdown list if open
  hide(event) {
    if (event.target !== this.element) {
      this.#hideList();
    }
  }

  // clicking anywhere _outside_ the revealed list will hide the list.
  hideOnClickOutside(event) {
    if (!this.listTarget.contains(event.target)) {
      this.#hideList();
    }
  }

  #isListShown() {
    return this.listTarget.style.display === 'block';
  }

  #hideList() {
    this.listTarget.style.display = 'none';
    this.triggerTarget.classList.remove('active');
  }

  #showList() {
    const toggleHeight = this.triggerTarget.offsetHeight;
    // position dropdown list below the dropdown toggle button
    this.listTarget.style.top = toggleHeight - 4 + 'px';
    this.listTarget.style.display = 'block';

    this.triggerTarget.classList.add('active');
    this.dispatch('shown');
  }
}
